import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Typography from "@mui/material/Typography";
import { useNavigate, useLocation } from "react-router-dom";
import { TbList } from "react-icons/tb";
import { PiUserList } from "react-icons/pi";
import { BsSearch } from "react-icons/bs";
import useMediaQuery from "@mui/material/useMediaQuery";
import { PiUserCircle } from "react-icons/pi";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { LiaHeadsetSolid } from "react-icons/lia";
import { GoTasklist } from "react-icons/go";
import { IoMailOpenOutline } from "react-icons/io5";
import { PiUserSound } from "react-icons/pi";
import { BsCreditCard2Front } from "react-icons/bs";
import { LiaUserEditSolid } from "react-icons/lia";
import { BsViewList } from "react-icons/bs";
import { GoMultiSelect } from "react-icons/go";
import Collapse from "@mui/material/Collapse";
import { PiHeadset } from "react-icons/pi";
import { BsLayoutTextSidebarReverse } from "react-icons/bs";
import { BsPlusSquare } from "react-icons/bs";
import { PiMailbox } from "react-icons/pi";
import { GoCrossReference } from "react-icons/go";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../../redux/profile/profileSlice";

const useStyles = makeStyles({
  drawerPaper: {
    border: "none !important",
    width: "18.333333% !important",
  },
});

export default function SideBar() {
  const theme = createTheme();
  const classes = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [openDrawer, setOpenDrawer] = React.useState(!isMobile);
  const [openDropdown, setOpenDropdown] = React.useState(false);
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [activeMenuItem, setActiveMenuItem] = React.useState(null);
  const profile = useSelector((state) => state.profile.data);

  let menuItems = [];
  if (profile?.profile?.role === "BENCH_SALES_RECRUITER") {
    menuItems = [
      {
        label: "Profile",
        icon: <PiUserCircle style={{ fontSize: "23.5px" }} />,
        route: "/profile",
      },

      {
        label: "Candiadte Listing",
        icon: <PiUserList style={{ fontSize: "24px" }} />,
        route: "/candidate-listing",
      },

      {
        label: "Hot Openings",
        icon: <GoMultiSelect style={{ fontSize: "23px" }} />,
        route: "/requirement",
      },

      {
        label: "Submissions Tracker",
        icon: <GoTasklist style={{ fontSize: "24px" }} />,
        route: "/Submissions Tracker",
      },

      {
        label: "Help Desk",
        icon: <PiHeadset style={{ fontSize: "24px" }} />,
        route: "/helpdesk",
      },
      {
        label: "Invite To Recruiter",
        icon: <GoCrossReference style={{ fontSize: "24px" }} />,
        route: "/invite",
      },
    ];
  } else {
    menuItems = [
      {
        label: "Profile",
        icon: <PiUserCircle style={{ fontSize: "23.5px" }} />,
        route: "/profile",
      },
      {
        label: "Job Post",
        icon: <BsPlusSquare style={{ fontSize: "20px" }} />,
        route: "/jobpost",
      },
      {
        label: "Profile Tracker",
        icon: <PiUserList style={{ fontSize: "24px" }} />,
        route: "/internal-tracker",
      },
      {
        label: "Submission Tracker",
        icon: <GoMultiSelect style={{ fontSize: "24px" }} />,
        route: "/submision-tracker",
      },
      {
        label: "MassMailing",
        icon: <PiMailbox style={{ fontSize: "23px" }} />,
        route: "/mass-mailing",
      },
      {
        label: "Help Desk",
        icon: <PiHeadset style={{ fontSize: "24px" }} />,
        route: "/helpdesk",
      },
      {
        label: "Invite To Bench Sales",
        icon: <GoCrossReference style={{ fontSize: "24px" }} />,
        route: "/invite",
      },
      // {
      //   label: "Search Candidate",
      //   icon: <BsPlusSquare />,
      //   route: "/search-candidate",
      // },

      // {
      //   label: "Dashboard",
      //   icon: <TbList style={{fontSize:'24px'}}/>,
      //   route: "/dashboard",
      // },
      // {
      //     label: "Notification",
      //     icon: <NotificationsActiveOutlinedIcon />,
      //     route: "/notification",
      // },
      // {
      //   label: "Post Requirement",
      //   icon: <NewspaperOutlinedIcon />,
      //   route: "/post-job-requirement",
      // },

      // {
      //   label: "Job Post",
      //   icon: <BsViewList style={{ fontSize: "21px" }} />,
      //   route: "/post-search-list",
      // },
      // {
      //   label: "Search Candidate",
      //   icon: <BsPlusSquare />,
      //   route: "/search-candidate",
      // },
      // {
      //   label: "Requirements",
      //   icon: <  GoMultiSelect style={{fontSize:'23px'}}/>,
      //   route: "/requirements",
      // },

      // {
      //   label: "Portal Submission",
      //   icon: <GoChecklist style={{fontSize:'23px'}}/>,
      //   route: "/portal-submission",
      // },
      // {
      //   label: "Internal Tracker",
      //   icon: <GoTasklist style={{ fontSize: "24px" }} />,
      //   // route: "/internal-tracker",
      //   children: [
      //     {
      //       label: "Candidates",
      //       icon: <PiUserList style={{ fontSize: "24px" }} />,
      //       route: "/internal-tracker",
      //     },
      //     {
      //       label: "Requirements",
      //       icon: <GoMultiSelect style={{ fontSize: "24px" }} />,
      //       route: "/requirements-tracker",
      //     },
      //   ],
      // },

      // {
      //   label: "Internal Submission",
      //   icon: <SummarizeOutlinedIcon />,
      //   route: "/internal-submission",
      // },
      // {
      //   label: "Update Status",
      //   icon: <LiaUserEditSolid style={{fontSize:'23px'}}/>,
      //   route: "/update-status",
      // },
      // {
      //   label: "Interview",
      //   icon: < LiaHeadsetSolid style={{fontSize:'23px'}}/>,
      //   route: "/interview",
      // },

      // {
      //   label: "RoleMapping",
      //   icon: <PiUserSound style={{fontSize:'23px'}}/>,
      //   route: "/Role-mapping",
      // },
      // {
      //   label: "Credit History",
      //   icon: <BsCreditCard2Front  style={{fontSize:'23px'}}/>,
      //   route: "/credit-history",
      // },

      // {
      //   label: "Feedback",
      //   icon: <IoMailOpenOutline style={{fontSize:'23px'}}/>,
      //   route: "/feedback",
      // },
    ];
  }

  React.useEffect(() => {
    if (profile === null) {
      dispatch(getProfile());
    }
  }, [profile]);

  React.useEffect(() => {
    const currentMenuItem = menuItems.find((item) =>
      location.pathname.startsWith(item.route)
    );
    setActiveMenuItem(currentMenuItem ? currentMenuItem.label : null);
  }, [location]);

  const handleDrawerToggle = () => {
    setOpenDrawer(!openDrawer);
  };

  const handleDropdownToggle = () => {
    setOpenDropdown(!openDropdown);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: "flex", background: "#485973", overflowY: "hidden" }}>
        {isMobile && (
          <IconButton color="inherit" onClick={handleDrawerToggle}>
            <MenuIcon />
          </IconButton>
        )}

        <Drawer
          variant={isMobile ? "temporary" : "permanent"}
          anchor="left"
          open={openDrawer}
          onClose={handleDrawerToggle}
          sx={{
            position: isMobile ? "fixed" : "static",
            height: isMobile ? "100%" : "auto",
            background: "#DBDFEA",
          }}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <List
            sx={{
              background: "#fff",
              marginTop: "1.5rem",
              pt: 2,
              overflowY: "auto",
              scrollbarWidth: "thin",
              "&::-webkit-scrollbar": {
                width: "12px",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "transparent",
                borderRadius: "6px",
              },
              height: isMobile ? "100%" : "100vh",
            }}
          >
            <img
              // src={logo}
              width="150px"
              height="auto"
              alt=""
              style={{
                justifyContent: "center",
                marginLeft: "50px",
                marginBottom: "5px",
              }}
            />
            {menuItems.map((item, index) => (
              <React.Fragment key={index}>
                <ListItem
                  disablePadding
                  onClick={() => {
                    if (item.children) {
                      handleDropdownToggle();
                    } else {
                      Navigate(item.route);
                      if (isMobile) {
                        handleDrawerToggle();
                      }
                    }
                  }}
                  sx={{
                    backgroundColor:
                      activeMenuItem === item.label ? "#ccc" : "transparent",
                  }}
                >
                  <ListItemButton>
                    <ListItemIcon
                      sx={{ color: "#3f475a", minWidth: "40px !important" }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText>
                      <Typography
                        variant="h2"
                        sx={{
                          color: "#3f475a",
                          fontSize: "15px",
                          fontFamily: "Calibri",
                          fontWeight: "500",
                        }}
                      >
                        {item.label}
                      </Typography>
                    </ListItemText>
                    {item.children ? (
                      openDropdown ? (
                        <ExpandLess />
                      ) : (
                        <ExpandMore />
                      )
                    ) : null}
                  </ListItemButton>
                </ListItem>
                {item.children && (
                  <Collapse in={openDropdown} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {item.children.map((child, childIndex) => (
                        <ListItem
                          key={childIndex}
                          disablePadding
                          onClick={() => {
                            Navigate(child.route);
                            if (isMobile) {
                              handleDrawerToggle();
                            }
                          }}
                          sx={{
                            backgroundColor:
                              location.pathname === child.route
                                ? "#ccc"
                                : "transparent",
                          }}
                        >
                          <ListItemButton
                            sx={{ padding: "0 0 0 10px !important" }}
                          >
                            <ListItemText>
                              <ListItemButton>
                                <ListItemIcon
                                  sx={{
                                    color: "#3f475a",
                                    minWidth: "40px !important",
                                  }}
                                >
                                  {item.icon}
                                </ListItemIcon>
                                <Typography
                                  variant="h2"
                                  sx={{
                                    color: "#3f475a",
                                    fontSize: "15px",
                                    fontFamily: "Calibri",
                                    fontWeight: "500",
                                  }}
                                >
                                  {child.label}
                                </Typography>
                              </ListItemButton>
                            </ListItemText>
                          </ListItemButton>
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                )}
              </React.Fragment>
            ))}
          </List>
        </Drawer>
      </Box>
    </ThemeProvider>
  );
}
